import * as Sentry from '@sentry/nextjs';

const clientConfig = (typeof window !== 'undefined' && window.__CONFIG__) || {};
const SENTRY_DSN = clientConfig.SENTRY_DSN;
const APP_ENV = clientConfig.APP_ENV;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    tracesSampleRate: 1.0,
    environment: APP_ENV,
  });
} else {
  // eslint-disable-next-line no-console
  console.info('Sentry DSN is not set - skipping initialization');
}
